// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"styles_sectionTitle__FsJ8U","title":"styles_title__OWb__","description":"styles_description__Yan9x"};